import React, { useState } from "react";

const Udyam = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="p-8 bg-gray-100">
      {/* Title Section */}
      <h1 className="text-3xl font-bold text-center mb-6">Udyam Registration</h1>
      <p className="text-gray-700 mb-6 text-center">
        Udyam Registration is the new online process for registering Micro, Small, and Medium Enterprises (MSMEs) in India. It was launched by the Ministry of MSME on July 1, 2020, replacing the previous Udyog Aadhaar Memorandum (UAM) system.
      </p>

      {/* Accordion Sections */}
      <div className="space-y-4 mx-4 sm:mx-10 lg:mx-40">
        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            activeSection  === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full flex items-center text-white justify-between px-4 py-3 text-lg font-semibold "
          >
            1. Key Features Of Udyam Registration
            <span>{activeSection === 1 ? "-" : "+"}</span>
          </button>
          {activeSection === 1 && (
            <ul className="list-disc pl-6 py-2 bg-white text-gray-700">
              <li className="font-bold">Online and paperless:</li> The entire registration process is online and requires no physical documents.  
              <li className="font-bold">Self-declaration:</li> Businesses can self-declare their information without needing to provide any proof or certificates
              <li className="font-bold">Based on investment and turnover:</li> The classification of MSMEs is based on a composite criterion of investment in plant and machinery or equipment and annual turnover.  
              <li className="font-bold">Permanent identification number:</li> Upon registration, an enterprise is assigned a permanent identification number known as the 'Udyam Registration Number'.
              <li className="font-bold">E-certificate:</li> An e-certificate, namely, 'Udyam Registration Certificate', is issued online upon completion of the registration process. This certificate has a dynamic QR code containing details about the enterprise.  
            </ul>
          )}
        </div>

         <div
          className={`border rounded-lg ${
            activeSection  === 2 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(2)}
            className="w-full text-white flex items-center justify-between px-4 py-3 text-lg font-semibold "
          >
            2.Benefits of Udyam Registration:
            <span>{activeSection === 2 ? "-" : "+"}</span>
          </button>
          {activeSection === 2 && (
        <ul className="list-disc pl-6 py-2 bg-white text-gray-700">
          <li> Access to government schemes and benefits: Registered MSMEs can avail various benefits offered by the government, such as subsidies, loans, and tax exemptions.</li>
          <li>Priority lending: Banks often provide priority lending to registered MSMEs</li>
          <li>Tender preference: Registered MSMEs may get preference in government tenders.</li>
          <li>Easier access to credit: It becomes easier for MSMEs to obtain credit from financial institutions.</li> 
          <li>Reduced compliance burden: Udyam Registration simplifies the compliance process for MSMEs.</li> 
        </ul>
          )}
      </div>


      <div
          className={`border rounded-lg ${
            activeSection === 3 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(3)}
            className="w-full  text-white flex items-center justify-between px-4 py-3 text-lg font-semibold "
          >
            3. Who Can Register?
            <span>{activeSection === 3 ? "-" : "+"}</span>
          </button>
          {activeSection === 3 && (
            <ul className="list-disc pl-6 py-2 bg-white text-gray-700">
             <p>Any person who intends to establish a micro, small, or medium enterprise can file for Udyam Registration. Existing enterprises registered under EM Part-II or UAM were also required to re-register on the Udyam Registration portal.</p>
            </ul>
          )}
        </div>

        {/* Section 4 */}
        <div
          className={`border rounded-lg ${
            activeSection === 4 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(4)}
            className="w-full text-white flex text-white items-center justify-between px-4 py-3 text-lg font-semibold "
          >
            4. Documents Requirement
            <span>{activeSection === 4 ? "-" : "+"}</span>
          </button>
          {activeSection === 4 && (
            <ul className="list-disc pl-6 py-2 bg-white text-gray-700">
              <li>PAN Card & Aadhar Card Details of the proprietor/ all the directors/all the partners.</li>
              <li>Proof of ownership of the place being used as a Registered Office such as the Allotment Letter/Lease Agreement/Possession Letter/Property Tax Receipt.</li>
              <li>If in case the place being used is a rented premise, then the Rent Agreement with the No-Objection Certificate (NOC) from the landlord together with the utility bill.</li>
              <li>A Copy of Partnership Deed in the case of a Partnership Firm.</li>
              <li>Copy of Memorandum of Association (MOA) and Articles of Association (AOA) and Certificate of Incorporation (COI) in the case of Private Limited Company together with the Board's Resolution passes authorizing the director to sign the application.</li>
              <li>Bank Account Details.</li>
            </ul>
          )}
        </div>
      </div>

      {/* Get in Touch Section */}
      <div className="bg-white shadow-md rounded-lg p-6 mt-6">
        <h2 className="text-lg font-semibold mb-2 ">Get in touch</h2>
        <p className="text-gray-700 mb-4">
          If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
        </p>
        <div className="flex space-x-4">
          <button onClick={handleAppointmentClick}  className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600">
            Make Appointment
          </button>
          <button className="bg-b[#005A8C] text-white px-4 py-2 rounded hover:bg-blue-600">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default Udyam;
